'use client';

import { storage } from '@segments/Storage';
import * as React from 'react';
import { StorageProvider as Provider, useStorageCtx } from '~logic/storage/StorageProvider';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * wrapper rendering the generic storage provider from `logic` module
 * with speedlo-waiter storage instance
 * use the `useStorage` hook to access this storage instance
 */
export var StorageProvider = function StorageProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Provider, {
    storage: storage,
    children: children
  });
};
export { useStorageCtx as useStorage };